import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_winnerbot.png",
      alt: "Estratégias WinnerBot",
    },
    title: "Opere com a WinnerBot",

    // String ou array de strings
    text: [
      "A união faz força! Esse é o segredo da WinnerBot.",
      "Com mais de 7 anos de mercado temos as melhores estratégias que somam as suas forças para vencerem em qualquer momento do mercado.",
    ],
    // testimonial: {
    //   text: "",
    //   author: {
    //     name: "",
    //     picture: "",
    //   },
    // },
  },
  strategies: {
    title: "Estratégias WinnerBot",
    heading: "Algoritmos avançados à sua disposição.",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
  stats: {
    title: "Alguns números do portfólio WinnerBot*",
    subtitle:
      "Mais de 7 anos de experiência operando de forma automatizada em escala global.",
    smalltext: "*Baseado no lote mínimo recomendado do portfólio.",
    data: [
      {
        value: "72",
        description: "Número de Meses",
      },
      {
        value: "63",
        description: "Meses com Gain",
      },
      {
        value: "9",
        description: "Meses com Perda",
      },
      {
        value: "2,53",
        description: "Fator de Lucro",
      },
      {
        value: "1,46",
        description: "Pay Off",
      },
      {
        value: "65,66%",
        description: "Gain x DrawDown",
      },
      {
        value: "10",
        description: "Maior Sequência de Perda (dias)",
      },
      {
        value: "17",
        description: "Maior Sequência de Gain (dias)",
      },
      {
        value: "R$ 1.442,00",
        description: "Média de ganho mensal",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da WinnerBot?",
    subtitle: "Veja quais as principais vantagens dos robôs da WinnerBot.",
    data: [
      {
        icon: iconsSet.click,
        title: "Simplicidade",
        description:
          "Estratégias simples, comprovadamente rentáveis e cuidadosamente otimizadas e testadas em conta real.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.pie_chart_2,
        title: "Opere um portfólio",
        description:
          "Oferecemos um portfólio balanceado, priorizando sempre uma curva de capital suave com ótima relação gain x drawdown.",
      },
      ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão WinnerBot.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A WinnerBot",
    col1: [
      "A WinnerBot desenvolve estratégias para day-trade e swing-trade com foco no mercado futuro de índice e dólar. Atua no mercado financeiro com soluções automatizadas deste 2012. A partir de 2016 iniciou o desenvolvimento e operação de estratégias próprias.",

      "Somos traders. Nossas estratégias são validadas em conta real!",
    ],
    col2: [
      "Oferecemos aos clientes da OnTick um portfólio com múltiplas estratégias validadas pelo período de pelo menos 2 anos em conta real, com resultado médio muito superior às estratégias isoladas.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão WinnerBot",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
